import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fileexplorer-dialog',
    templateUrl: 'fileexplorer.dialog.html',
    styleUrls: ['./fileexplorer.dialog.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileExplorerDialog {
    MediaSourceID;
    Selection = null;
    ImageInstance;
    FixedPath;
    /** Dateibrowser aus der Medienquellen-Pflege statt Auswahldialog. */
    ManageMode = false;
    Title: string = null;

    constructor(private dialogRef: MatDialogRef<FileExplorerDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.MediaSourceID = data.MediaSourceID;
            this.ImageInstance = data.ImageInstance;
            this.FixedPath = data.FixedPath;
            this.ManageMode = data.ManageMode === true;
            this.Title = data.Title ?? null;
        }
    }

    okClicked() {
        this.dialogRef.close(this.Selection);
    }

    cancelClicked() {
        this.dialogRef.close();
    }

    onFileUploaded(ev) {
        if (this.ImageInstance && typeof this.ImageInstance.onFileUploaded === 'function') {
            this.ImageInstance.onFileUploaded(ev);
        }
    }
}
